import React from 'react'
import { FormattedMessage } from 'react-intl'
import {
  AccordionSummary,
  Typography,
  AccordionDetails,
  Accordion, Fade
} from '@material-ui/core'
import { useStyles } from './Styles'
import ArrowUpwardOutlinedIcon from '@material-ui/icons/ArrowUpwardOutlined'
import ArrowDownwardOutlinedIcon from '@material-ui/icons/ArrowDownwardOutlined'
import { FormLoader } from '../Loader/FormLoader'
import invoicesStatus from '../../configurations/invoices-status'
import { LanguageConsumer } from '../../context/LanguageContext'
import { getStatusIcon } from '../../utils/helpers'

const StatesBox = ({ issuer, states, loading }) => {
  const classes = useStyles()
  const [stateSum, setStateSum] = React.useState(0)

  React.useEffect(() => {
      if (!!Object.keys(states || {}).length) {
        setStateSum(Object.keys(states || {}).reduce((total, key) => states[key]?.count + total, 0))
      }
    }, // eslint-disable-next-line react-hooks/exhaustive-deps
    [states])
  return (
    <div className={classes.AmountBoxWrapper}>
      <Accordion expanded={true} elevation={4} className={classes.AmountBox + (!!issuer ? ' issuer' : ' receiver')}>
        <AccordionSummary
          expandIcon={<></>}
          aria-controls="panel1a-content"
          id="panel1a-header"
        >
          <div className={classes.AmountBoxHeadingWrapper}>
            <Typography className={classes.ItemHeading}>{!!issuer ? <ArrowUpwardOutlinedIcon color={'primary'}/> :
              <ArrowDownwardOutlinedIcon color={'secondary'}/>}<FormattedMessage
              id={`dashboard.StatesBox.Title.${!!issuer ? 'issuer' : 'receiver'}`}/></Typography>
          </div>
        </AccordionSummary>
        <AccordionDetails>
          {!!loading && <FormLoader loading={loading}/>}
          <Fade in={!!Object.keys(states || {})?.length}>
            <LanguageConsumer>
              {({ locale }) => (
                <div className={classes.AmountBoxContent}>
                  {Object.keys(states || {})?.map((stateKey, index) => {
                      let status = invoicesStatus?.filter(item => item.key.toString().toLowerCase() === stateKey?.toString()?.toLowerCase())
                      return (
                        <div key={index} className={classes.StateRow + ` ${stateKey?.toString()?.toLowerCase()}`}>
                          <label>{getStatusIcon(status[0]['key'])} <strong>{status[0][`name_${locale}`]}</strong></label>
                          <div className={classes.amountValue}>
                            <span className={'state-value'}>{states[stateKey]?.count}</span>
                            <span className={classes.stateValueWrapper}><span className={classes.stateValue}
                                                                              style={{ width: (states[stateKey]?.count / stateSum) * 100 + '%' }}></span></span>
                          </div>
                        </div>
                      )
                    }
                  )}
                </div>
              )}
            </LanguageConsumer>
          </Fade>
        </AccordionDetails>
      </Accordion>
    </div>
  )
}

export default StatesBox
